type SemVer = [number, number, number];

export const parseSemVer = (version: string): SemVer | null => {
  const match = /^(\d+)\.(\d+)\.(\d+)$/.exec(version.trim());
  if (!match) {
    return null;
  }
  return [Number(match[1]), Number(match[2]), Number(match[3])];
};

export const isValidSemVer = (version: string): boolean => parseSemVer(version) !== null;

export const compareSemVer = (a: SemVer, b: SemVer): number => {
  for (let i = 0; i < 3; i++) {
    if (a[i] !== b[i]) {
      return a[i] - b[i];
    }
  }
  return 0;
};
